import styled from "styled-components";

const Styles = styled.h1`
  font-family: AvertaStdCY-Bold;
  margin-block-start: 0px;
  margin-block-end: 0px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-size: 1.6em;
  color: black;
`;

export default Styles;
